function adjustProductLayout() {
  if (window.innerWidth >= 769) {
    document
      .querySelectorAll(".product__outer--single-aside")
      .forEach((elem) => {
        elem.classList.add("product__outer--static-column-aside");
        elem.classList.remove("product__outer--single-aside");
      });

    document
      .querySelectorAll(".product__media-list--auto-enabled")
      .forEach((elem) => {
        //elem.classList.remove("js-media-list", "swiper");
      });

    document
      .querySelectorAll(".product__media-list .swiper-wrapper")
      .forEach((elem) => {
        elem.className = "";
      });

    document
      .querySelectorAll(".product__media-list .product__pagination-wrapper")
      .forEach((elem) => {
        elem.style.display = "none";
      });

    document
      .querySelectorAll(".product__media-list .product__slider-nav")
      .forEach((elem) => {
        elem.style.display = "none";
      });
  } else {
    document
      .querySelectorAll(".product__outer--static-column-aside")
      .forEach((elem) => {
        elem.classList.add("product__outer--single-aside");
        elem.classList.remove("product__outer--static-column-aside");
      });

    document
      .querySelectorAll(".product__media-list--auto-enabled")
      .forEach((elem) => {
        elem.classList.add("js-media-list", "swiper");
      });

    document
      .querySelectorAll(".js-media-list > div:first-of-type")
      .forEach((elem) => {
        elem.classList.add("swiper-wrapper");
      });

    document
      .querySelectorAll(".product__media-list .product__pagination-wrapper")
      .forEach((elem) => {
        elem.style.display = "flex";
      });

    document
      .querySelectorAll(".product__media-list .product__slider-nav")
      .forEach((elem) => {
        elem.style.display = "none";
      });
  }
}

//   document.addEventListener("DOMContentLoaded", adjustProductLayout);

//   window.addEventListener("resize", () => {
//     adjustProductLayout();
//     sliderInit(true);
//   });
// })();

(function () {
  const initSlider = () => {
    let productSlider;
    const productSliders = document.querySelectorAll(".js-media-list");

    if (window.innerWidth < 769) {
      productSliders.forEach((elem, index) => {
        let prevButton = elem.querySelector(
          ".product__slider-nav .swiper-button-prev"
        );
        let nextButton = elem.querySelector(
          ".product__slider-nav .swiper-button-next"
        );
        let pagination = elem.querySelector(".product__pagination");
        productSlider = new Swiper(elem, {
          slidesPerView:
            elem
              .closest(".product__outer")
              .classList.contains("product__outer--full-screen") ||
            elem
              .closest(".product__outer")
              .classList.contains("product__outer--single-aside") ||
            elem
              .closest(".product__outer")
              .classList.contains("product__outer--thumbs-aside")
              ? 1
              : 1.1,
          spaceBetween: elem
            .closest(".product__outer")
            .classList.contains("product__outer--multiple-top")
            ? 0
            : 1,
          autoHeight: true,
          speed: 500,
          freeMode: {
            enabled: !!elem
              .closest(".product__outer")
              .classList.contains("product__outer--multiple-top"),
            sticky: true,
          },
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          pagination: {
            el: pagination,
            type: "bullets",
            clickable: true,
          },
          thumbs: {
            swiper: elem.nextElementSibling.querySelector(".js-media-sublist")
              ? elem.nextElementSibling.querySelector(".js-media-sublist")
                  .swiper
              : "",
          },
          breakpoints: {
            769: {
              slidesPerView:
                elem
                  .closest(".product__outer")
                  .classList.contains("product__outer--full-screen") ||
                elem
                  .closest(".product__outer")
                  .classList.contains("product__outer--single-aside") ||
                elem
                  .closest(".product__outer")
                  .classList.contains("product__outer--thumbs-aside")
                  ? 1
                  : 2.37,
            },
          },
          on: {
            afterInit: function (swiper) {
              if (document.querySelector(".product__outer--multiple-top")) {
                document
                  .querySelectorAll(".product__media-toggle")
                  .forEach((elem, index) => {
                    elem.addEventListener("click", (e) => {
                      var target = e.currentTarget;

                      if (
                        document.querySelector(".js-popup-slider") &&
                        document.querySelector(".js-popup-slider").swiper
                      ) {
                        document
                          .querySelector(".js-popup-slider")
                          .swiper.slideTo(index);
                      }
                    });
                  });
              }
            },
            slideChangeTransitionStart: function () {
              if (document.querySelector(".js-media-sublist")) {
                document
                  .querySelector(".js-media-sublist")
                  .swiper.slideTo(
                    document.querySelector(".js-media-list").swiper.activeIndex
                  );
              }
            },
            slideChange: function () {
              window.pauseAllMedia();
              this.params.noSwiping = false;

              if (
                document.querySelector(".js-popup-slider") &&
                document.querySelector(".js-popup-slider").swiper &&
                !document.querySelector(".product__outer--multiple-top")
              ) {
                document
                  .querySelector(".js-popup-slider")
                  .swiper.slideTo(this.activeIndex);
              }
            },
            slideChangeTransitionEnd: function () {
              if (this.slides[this.activeIndex].querySelector("model-viewer")) {
                this.slides[this.activeIndex]
                  .querySelector(".shopify-model-viewer-ui__button--poster")
                  .removeAttribute("hidden");
              }
            },
            touchStart: function () {
              if (this.slides[this.activeIndex].querySelector("model-viewer")) {
                if (
                  !this.slides[this.activeIndex]
                    .querySelector("model-viewer")
                    .classList.contains("shopify-model-viewer-ui__disabled")
                ) {
                  this.params.noSwiping = true;
                  this.params.noSwipingClass = "swiper-slide";
                } else {
                  this.params.noSwiping = false;
                }
              }
            },
          },
        });
      });

      document
        .querySelectorAll(".product__outer--static-column-aside")
        .forEach((elem) => {
          elem.classList.add("product__outer--single-aside");
          elem.classList.remove("product__outer--static-column-aside");
        });

      document
        .querySelectorAll(".product__media-list--auto-enabled")
        .forEach((elem) => {
          elem.classList.add("js-media-list", "swiper");
        });

      document
        .querySelectorAll(".js-media-list > div:first-of-type")
        .forEach((elem) => {
          elem.classList.add("swiper-wrapper");
        });

      document
        .querySelectorAll(".product__media-list .product__pagination-wrapper")
        .forEach((elem) => {
          elem.style.display = "flex";
        });

      document
        .querySelectorAll(".product__media-list .product__slider-nav")
        .forEach((elem) => {
          elem.style.display = "none";
        });
    } else {
      document
        .querySelectorAll(".product__outer--single-aside")
        .forEach((elem) => {
          elem.classList.add("product__outer--static-column-aside");
          elem.classList.remove("product__outer--single-aside");
        });

      document
        .querySelectorAll(".product__media-list--auto-enabled")
        .forEach((elem) => {
          elem.classList.remove("js-media-list", "swiper");
        });

      document
        .querySelectorAll(".product__media-list .swiper-wrapper")
        .forEach((elem) => {
          elem.className = "";
        });

      document
        .querySelectorAll(".product__media-list .product__pagination-wrapper")
        .forEach((elem) => {
          elem.style.display = "none";
        });

      document
        .querySelectorAll(".product__media-list .product__slider-nav")
        .forEach((elem) => {
          elem.style.display = "none";
        });
    }
  };

  const destroySlider = () => {
    const productSliders = document.querySelectorAll(".js-media-list");

    productSliders.forEach((slider, index) => {
      console.log("slider.swiper", slider.swiper);
      if (slider.swiper) slider.swiper.destroy();
    });
  };

  const initSection = () => {
    const sections = document.querySelectorAll(".product-section");

    const sectionResizeObserver = new ResizeObserver((entries) => {
      destroySlider();
      initSlider();
    });

    destroySlider();
    initSlider();
    subSliderInit(true);
    popupSliderInit(true);

    sections.forEach((item) => {
      sectionResizeObserver.observe(item);
    });
  };

  initSection();
})();
